export const methodRegistry = new Set<{
  className: string;
  methodDefinition: string;
  comment: string;
  async: boolean;
}>();

export function MethodInfo(definition: {
  className: string;
  methodDefinition: string;
  comment: string;
  async: boolean;
  return: string;
}) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    methodRegistry.add(definition);
  };
}
